import { selectUserContext } from 'core/userContext';
import { COMMAND_GROUP_ITEMS } from 'modules/quickActionsMenu/constants';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { PAGE } from 'modules/quickActionsMenu/types';
import { doesUserHaveAccess } from 'modules/quickActionsMenu/utils';
import { useSelector } from 'react-redux';
import { Insert16, KeyEnter } from 'ui/icons';
import { colors } from 'ui/theme';
import noop from 'utils/noop';
import { Action, Item } from '../Item';
import { CommandGroup } from '../Styled';

export const CommandsGroup = () => {
  const { navigate, pageState, selectPage } = useQuickActionsMenuContext();
  const { featureFlags = {}, rbacPermissions = [] } = useSelector(selectUserContext);

  const handleSelect = (page?: PAGE, url?: string, urlName?: string) => {
    if (page) {
      return selectPage({ page, previousPage: pageState?.page });
    }

    return url ? navigate({ pageName: urlName, path: url }) : noop();
  };

  const filteredItems = COMMAND_GROUP_ITEMS.filter((item) =>
    doesUserHaveAccess(item, rbacPermissions, featureFlags),
  );

  return (
    <CommandGroup heading="Commands">
      {filteredItems.map((item) => {
        return (
          <Item
            Icon={<Insert16 color={colors.iconSubtle} />}
            key={item.name}
            name={item.name}
            onSelect={() => handleSelect(item?.page, item?.url, item?.name)}
            value={item.name}
          >
            <Action prefix="Press" Key={<KeyEnter isColorInherited />} action="create" />
          </Item>
        );
      })}
    </CommandGroup>
  );
};
